export default "__VITE_ASSET__B3tlF5mU__"